import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';
import plateBg from '../../assets/images/plate_classic_bg.png';

const StyledContainer = styled.div<{ $black?: boolean }>`
	position: relative;
	width: 260px;
	height: 70px;
	background-color: ${(props) =>
		props.$black ? 'rgba(255, 255, 255, 0.1)' : '#f4f4f4'};
	border-radius: 10px;
	background-image: url(${plateBg});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
`;

const StyledStroke = styled.div<{ $black?: boolean }>`
	position: absolute;
	top: 2px;
	left: 2px;
	bottom: 2px;
	right: 2px;
	opacity: 0.5;
	border: 1px solid ${(props) => (props.$black ? '#ffffff' : '#000000')};
	border-radius: 9px;
`;

const StyledCircle = styled.div<{
	$position: 'left' | 'right';
	$black?: boolean;
}>`
	position: absolute;
	top: 50%;
	${(props) =>
		props.$position === 'left'
			? css`
					left: 8px;
			  `
			: css`
					right: 8px;
			  `}
	transform: translateY(-50%);
	width: 6px;
	height: 6px;
	background-color: ${(props) => (props.$black ? '#ffffff' : '#000000')};
	border-radius: 6px;
`;

const StyledLetters = styled(Text)<{ $black?: boolean }>`
	font-weight: 700;
	font-size: 30px;
	line-height: 34px;
	color: ${(props) => (props.$black ? '#ffffff' : '#000000')};
	text-shadow:
		-2px -2px 0px rgba(255, 255, 255, ${(props) => (props.$black ? '0.15' : '0.75')}),
		2px 2px 0px rgba(0, 0, 0, 0.1);
`;

const StyledNumberContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	justify-content: center;
`;

export {
	StyledCircle,
	StyledContainer,
	StyledLetters,
	StyledNumberContainer,
	StyledStroke,
};
